import { render, staticRenderFns } from "./fee-designations-grid.vue?vue&type=template&id=4ccf4da1&"
import script from "./fee-designations-grid.vue?vue&type=script&lang=ts&"
export * from "./fee-designations-grid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports